
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lifestyle/news/[id]",
      function () {
        return require("private-next-pages/lifestyle/news/[id].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lifestyle/news/[id]"])
      });
    }
  